import React from 'react';
import { convertStyles } from '@kibt/krn-utils';
// eslint-disable-next-line no-restricted-imports
import { TouchableOpacity, View, Text } from 'react-native';
import { PageContext, KImage, KImageBackground } from '@/component/RtlLayout';
import SrcStyles from './index.styl';
import { scaleW, vw, vwWithPC } from '@/common/style';
import { logClickAssuredPurchaseBar, logShowAssuredPurchaseBar } from '@/page/detail/views/logger2.0';
import { $k18n } from '@/common/i18n';
import { ViewVisible } from '@/component/ViewVisible/ViewVisible';
import { isMobileDeviceValue } from '@/common/device-info';
import { onShowGuaranteeV1 } from '../../../jump';

const Styles = convertStyles(SrcStyles);

const ProductGuarantee = ({ itemId }) => {
    const GUARANTEE_LIST = [
        {
            title: 'k_1214534', // 交货保证
            desc: 'k_1214536',
        },
        {
            title: 'k_485557', // 安全支付
            desc: 'k_1214537',
        },
        {
            title: 'k_1214535', // 轻松退款
            desc: 'k_1214538',
        },
        {
            title: 'k_511446', // 放心购买
            desc: 'k_1214539',
        },
    ];

    return (
        <PageContext.Provider value={{ Styles }}>
            <ViewVisible rootMargin={{ top: 0, left: 0, right: 0, bottom: 100 }} onVisible={logShowAssuredPurchaseBar}>
                <View>
                    <KImageBackground
                        source={{ uri: 'https://cdn-static.kwai.net/kos/s101/nlav11312/shop-krn/Frame2036092024.png' }}
                        resizeMode="cover"
                        style={{
                            width: vwWithPC(100),
                            height: scaleW(36),
                        }}>
                        <TouchableOpacity
                            activeOpacity={1}
                            onPress={() => {
                                logClickAssuredPurchaseBar();
                                onShowGuaranteeV1(itemId, false, 'PURCHASE_SECURITY');
                            }}>
                            <View style={{"flexDirection":"row","alignItems":"center"}}>
                                <KImage
                                    source={{ uri: 'https://cdn-static.kwai.net/kos/s101/nlav11312/shop-krn/Ico10123.png' }}
                                    style={{"height":"3.8647342995169085rem","width":"3.8647342995169085rem","marginLeft":"3.381642512077295rem","marginRight":"0.9661835748792271rem"}}
                                    resizeMode="contain"
                                />
                                <View
                                    style={{
                                        height: scaleW(36),
                                        width: vwWithPC(80),
                                    }}>
                                    <Text
                                        style={{"lineHeight":"8.695652173913045rem","fontSize":"2.8985507246376816rem","fontWeight":"500","color":"rgba(5, 163, 0, 1)"}}
                                        numberOfLines={1}
                                        ellipsizeMode="tail">
                                        {GUARANTEE_LIST.map(item => $k18n({ id: item.desc })).join(' · ')}
                                    </Text>
                                </View>
                                <KImage
                                    source={{
                                        uri: 'https://cdn-static.kwai.net/kos/s101/nlav11312/shop-krn/kibt_post_import_album_icon_arrow_black_111.png',
                                    }}
                                    style={{"width":"3.8647342995169085rem","height":"3.8647342995169085rem"}}
                                />
                            </View>
                        </TouchableOpacity>
                    </KImageBackground>
                </View>
            </ViewVisible>
        </PageContext.Provider>
    );
};

export default ProductGuarantee;
